<header class="navbar navbar-fixed-top subnavbar bg-system" >
        
    <ul class="nav navbar-nav navbar-left hidden-xs" ng-if="isActive(['customer-reports'])">
        
        <li class="hidden-xs" ng-if="isActive(['customer-reports'])">
            <a class="navbar-fullscreen toggle-active" href="/customer-reports">
                <strong class="p10 fs18">Order Reports</strong>
            </a>
        </li>

        <input 
            type="text" 
            ng-model="filterData.term" 
            class="btn btn-operation ml10 text-input" 
            placeholder="Order Number" >
    
        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.scheduled_time" 
            class="btn btn-operation ml10" 
            placeholder="Order Date" >
            
        <!--
        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.created_time" 
            class="btn btn-operation ml10" 
            placeholder="Oluşturma Tarihi" >

        -->

        <!-- <select class="ml10 selectpicker" 
            multiple 
            title="Ekip"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.teams"
            data-style="btn-primary">
            <option ng-repeat="item in authenticatedUser.teams" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
        </select> -->
        
        <!-- <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select> -->
        
        <!-- <ui-select ng-model="filterData.customers" title="Müşteri" class="ml10 operation-live-search" style="width:200px" multiple>
            <ui-select-match placeholder="Müşteri Seçiniz...">{{ $item.customer_name }}</ui-select-match>
            <ui-select-choices refresh="searchCustomer($select,'')" refresh-delay="0" repeat="searchRes in searchRes">
                <span ng-bind-html="searchRes.customer_name | highlight: $select.search"></span>
            </ui-select-choices>
        </ui-select> -->
        
        <select class="ml10 selectpicker" 
            multiple 
            title="Order Status"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workSteps"
            data-style="btn-primary">
            <option ng-repeat="item in data.workSteps" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
        </select>

        <!-- <select class="ml10 selectpicker" 
            multiple 
            title="Kargo Türü"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workTypes"
            data-style="btn-primary">
            <option ng-repeat="item in data.workTypes" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
        </select> -->

        <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
            <i class="fa fa-times"></i>
        </a>

        <a href="#" class="btn btn-operation ml10" ng-click="refreshData('order_list')" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

    </ul>

    <ul class="nav navbar-nav navbar-left hidden-xs" ng-if="isActive(['customer-profit'])">
            
        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.scheduled_time" 
            class="btn btn-operation ml10" 
            placeholder="Kargo Tarihi" >

        
        <!-- <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select> -->


        <a href="#" class="btn btn-warning ml10" ng-click="refreshData('order_list')" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

        <a href="#" class="btn btn-operation ml10" ng-click="clearFilter()" style="line-height: 20px;">
            <i class="fa fa-times"></i>
        </a>

    </ul>

</header>